import { render, staticRenderFns } from "./DashboardCalendarAbsenceList.vue?vue&type=template&id=252cfda3"
import script from "./DashboardCalendarAbsenceList.vue?vue&type=script&lang=js"
export * from "./DashboardCalendarAbsenceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports